import axios from 'axios';
import { AdresseIP } from '../AdresseIP';

export class AuthentificationService {

    constructor(){
        this.adresse = new AdresseIP()
        this.backendUrl = 'service/api/diplome/no-auth'
    }

    
    
   getAuthentification (id) {
    const url = `${this.adresse.getAdresseIP()}/${this.backendUrl}/authentifier-diplome-hash/${id} `
    return axios.get(url).then(res => res.data) 
   }

   getAuthentificationCode (code) {
    const url = `${this.adresse.getAdresseIP()}/${this.backendUrl}/retrait-diplome?codeSticker=${code} `
    return axios.get(url).then(res => res.data) 
   }

}